import {Component, Input, OnInit, ViewEncapsulation, DestroyRef, inject} from '@angular/core';
import {filter, switchMap, take} from 'rxjs/operators';
import * as RA from 'ramda-adjunct';
import { Clipboard } from '@angular/cdk/clipboard';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AppInfoService} from '@emm/core/services/app-info.service';
import {AuthFacadeService} from '@emm/auth/services/auth-facade.service';
import {NotificationService} from '@emm/shared/services/notification.service';
import {UserService} from '@emm/core/services/user.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-app-info',
    styleUrls: ['./app-info.component.scss'],
    templateUrl: './app-info.component.html',
    standalone: false
})
export class AppInfoComponent implements OnInit {

    private readonly destroyRef: DestroyRef = inject(DestroyRef);

    appVersion: string;
    branch: string;
    buildTime: string;
    commit: string;
    commitToolTip: string;
    dbVersion: string;
    environment: string;
    menuUiUrl = 'https://github.com/cfacorp/menu-ui';
    releaseNotesUrl: string;
    userRoles: string;
    testingRole = this.userService.testingRole$;
    tokenTooltip = 'Copy bearer token to clipboard for use with Postman';
    isReadonly;

    @Input() uiVersion: string;

    constructor(
        private appInfoService: AppInfoService,
        private authFacade: AuthFacadeService,
        private notificationService: NotificationService,
        private userService: UserService,
        private clipboard: Clipboard) {}



    ngOnInit(): void {
        this.authFacade.isReadOnly$
            .pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(result => this.isReadonly = result);
        this.authFacade.isAuthenticated$
            .pipe(
                filter(RA.isTrue),
                take(1),
                switchMap( () => this.appInfoService.getAppInfo()),
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(({ built, database, environment, git: { branch, commit, message, user }, version }) => {
                this.appVersion = version;
                this.commit = commit;
                this.commitToolTip = `${message} | ${user} | ${branch}`;
                this.branch = branch;
                this.buildTime = built;
                this.dbVersion = database.version;
                this.environment = environment;
                this.releaseNotesUrl =
                    'https://github.com/cfacorp/menu-api#version-' +
                    version.replace('.', '').replace('.', '');
                try {
                    this.userRoles = this.userService.getUserRolesArray();
                } catch (e) {
                    if(!this.userService.userRoles.length) {
                        window.location.reload();
                    }
                }
            });
    }

    copyToken(): string {
        const oktaTokenString = sessionStorage.getItem('okta-token-storage');
        const oktaTokenJSON = JSON.parse(oktaTokenString);
        try {
            if (oktaTokenJSON?.idToken?.idToken) {
                this.clipboard.copy(oktaTokenJSON?.idToken?.idToken);
                this.notificationService.success(`Token Copied`);
            } else {
                this.notificationService.error('Error: No bearer token found');
            }
        } catch (e) {
            this.notificationService.error(e);
        }
        return oktaTokenJSON?.idToken?.idToken;
    }
}
